module.exports = __webpack_public_path__ + "img/objPolygon.8a572dc5.svg";